import React, { useState } from "react";

function Empflt() {
  const [showTable, setShowTable] = useState(false);
  const handeltoggle = () => {
    setShowTable(!showTable);
  };
  return (
    <>
      <div className="container ">
        <div className="both-btn">
          <button class="filtercls" onClick={handeltoggle}>
            {showTable ? "Hide Filter" : "Show Filter"}
          </button>
        </div>
        {showTable === true ? (
          <form>
            <div class="form-group nmg">
              <label class=" inpnmg" for="exampleInputEmail1">
                Id
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Id"
              />
            </div>
            <div class="form-group nmg">
              <label class=" inpnmg" for="exampleInputEmail1">
                Name
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Name"
              />
            </div>
            <div class="form-group nmg">
              <label class=" inpnmg" for="exampleInputEmail1">
                Address
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Address"
              />
            </div>
            <div class="form-group nmg">
              <label class=" inpnmg" for="exampleInputEmail1">
                Department
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Department"
              />
            </div>
            <div class="form-group nmg">
              <label class=" inpnmg" for="exampleInputEmail1">
                Position
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Position"
              />
            </div>

            <div class="att-fil-btn">
              <button type="button">Filter</button>
            </div>
          </form>
        ) : null}
      </div>
    </>
  );
}

export default Empflt;
